import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { readLanguageOverride, toAppLanguage } from "@/utilities/language";

/**
 * Puts the add-in into the language the user set on their own Geotab account.
 *
 * The account is only known once the session has been read, so this runs as soon as it arrives
 * rather than at start-up. A language picked in the header wins for as long as the tab is open:
 * it is there so someone can read the values in the English original for a while — the names the
 * vehicles actually report — without changing their account.
 */
export function useUserLanguage(): void {
  const { me } = useGeotabClient();
  const { i18n } = useTranslation();
  const userLanguage = toAppLanguage(me?.language);

  useEffect(() => {
    if (readLanguageOverride() !== null) {
      return;
    }
    if (userLanguage !== null && userLanguage !== i18n.language) {
      void i18n.changeLanguage(userLanguage);
    }
  }, [userLanguage, i18n]);
}
